import request from '@/utils/request';
import axios from 'axios';
const SNAPCHAT = process.env.VUE_APP_SNAPCHAT_AUTOGOODS;
const SNAPOPERATE = process.env.VUE_APP_GIAM_BASE;
// 获取枚举常量
export function getEnumConstants() {
  return request({
    baseURL: SNAPCHAT,
    url: `/snap/ads/getEnumConstants`,
    method: 'get',
  });
}

// 树形地区
export function queryTreeCountry() {
  return request({
    baseURL: SNAPCHAT,
    url: '/targeting/queryTreeCountry',
    method: 'get',
  });
}

// 预设受众
export function queryInterestByCountry(data) {
  return request({
    baseURL: SNAPCHAT,
    url: '/targeting/queryInterestByCountry',
    method: 'post',
    data,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}

// 生成广告层级预览
export function createAdPreview(data, that) {
  return request({
    baseURL: SNAPCHAT,
    url: '/snap/ads/createAdPreview',
    method: 'post',
    data,
    cancelToken: new axios.CancelToken(function executor(c) {
      // 设置 cancel token
      // console.log(c);
      if (that) {
        that.source = c;
      }
    }),
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}

// 上传广告
export function uploadAd(data) {
  return request({
    baseURL: SNAPCHAT,
    url: '/snap/ads/uploadAd',
    method: 'post',
    data,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}

// 获取受众规模
export function getAudienceSize(data, params) {
  return request({
    baseURL: SNAPCHAT,
    url: '/targeting/getAudienceSize',
    data,
    params,
    method: 'post',
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}

// 删除兴趣词
export function interestLabelDel(data) {
  return request({
    baseURL: SNAPCHAT,
    url: '/targeting/interestLabelDel',
    data,
    method: 'post',
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
// 查看story(故事广告)素材列表
export function queryStoryMediaPageApi(data) {
  return request({
    baseURL: SNAPCHAT,
    url: '/snap/media/queryStoryMediaPage',
    data,
    method: 'post',
    timeout: 60000,
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
// 查看story(故事广告)素材列表
export function querySpotlightMediaPageApi(data) {
  return request({
    baseURL: SNAPCHAT,
    url: '/snap/media/querySpotlightMediaPage',
    data,
    method: 'post',
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
// 将公众号素材转为广告素材
export function profile2AdMediaApi(data) {
  return request({
    baseURL: SNAPCHAT,
    url: '/snap/media/profile2AdMedia',
    data,
    method: 'post',
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
// 将公众号素材转为广告素材
export function queryPublicProfileByActIdApi(params) {
  return request({
    baseURL: SNAPOPERATE,
    url: '/snap/ast/profile/queryPublicProfileByActId',
    params,
    method: 'get',
    timeout: 60000,
  });
}
export function queryMediaStatusApi(data) {
  return request({
    baseURL: SNAPCHAT,
    url: '/snap/media/queryMediaStatus',
    data,
    method: 'post',
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
export function querySharedMediaPageApi(data) {
  return request({
    baseURL: SNAPCHAT,
    url: '/snap/media/querySharedMediaPage',
    data,
    method: 'post',
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}
export function queryAdPartnerProfilePageApi(data) {
  return request({
    baseURL: SNAPCHAT,
    url: '/snap/media/queryAdPartnerProfilePage',
    data,
    method: 'post',
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
  });
}

// 模拟获取创作者公众号列表
// export function queryCreatorProfilesApi(params) {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve({
//         code: 0,
//         data: [
//           {
//             profileId: 'creator_001',
//             displayName: '创作者公众号1'
//           },
//           {
//             profileId: 'creator_002',
//             displayName: '创作者公众号2'
//           },
//           {
//             profileId: 'creator_003',
//             displayName: '创作者公众号3'
//           }
//         ]
//       });
//     }, 500);
//   });
// }
